import { render } from "./ProjectsTestPage.vue?vue&type=template&id=872fab4c&ts=true"
import script from "./ProjectsTestPage.vue?vue&type=script&lang=ts"
export * from "./ProjectsTestPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__